import React from 'react';

const NearULogo = ({ size = 'medium', showText = false }) => {
  const sizes = {
    small: { height: '48px' },
    medium: { height: '70px' },
    large: { height: '140px' },
    xlarge: { height: '180px' }
  };

  const currentSize = sizes[size];

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: currentSize.height,
      position: 'relative'
    }}>
      {/* Gold glow effect behind logo */}
      <div style={{
        position: 'absolute',
        width: '120%',
        height: '120%',
        background: 'radial-gradient(circle, rgba(212, 175, 55, 0.15), transparent)',
        filter: 'blur(20px)',
        zIndex: 0
      }} />
      
      <img 
        src="https://customer-assets.emergentagent.com/job_socialux-app/artifacts/9izqox5r_IMG_1572.jpg"
        alt="Near U Logo"
        style={{ 
          height: currentSize.height,
          width: 'auto',
          objectFit: 'contain',
          maxWidth: '100%',
          filter: 'drop-shadow(0 0 20px rgba(212, 175, 55, 0.4)) drop-shadow(0 4px 12px rgba(0, 0, 0, 0.6))',
          position: 'relative',
          zIndex: 1,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
        onError={(e) => {
          console.error('Logo failed to load, trying fallback');
          e.target.src = '/nearu-logo.png';
        }}
        onMouseEnter={(e) => {
          e.target.style.filter = 'drop-shadow(0 0 30px rgba(212, 175, 55, 0.6)) drop-shadow(0 6px 16px rgba(0, 0, 0, 0.7))';
        }}
        onMouseLeave={(e) => {
          e.target.style.filter = 'drop-shadow(0 0 20px rgba(212, 175, 55, 0.4)) drop-shadow(0 4px 12px rgba(0, 0, 0, 0.6))';
        }}
      />
    </div>
  );
};

export default NearULogo;
